import { createApp } from "vue";
import App from "./App.vue";
import "./plugins/AdobeTypekit.js";
import router from "./router/index.js";
import "vuetify/dist/vuetify.min.css";
import * as components from "vuetify/components";
import * as directives from "vuetify/directives";
import VueScrollTo from "vue-scrollto";


// Vuetifyのインポート方法を変更
import { createVuetify } from "vuetify";

const app = createApp(App);

// Routerの設定
app.use(router);

//vscroll
app.use(VueScrollTo);

// Vuetifyの設定 カラーテーマの設定もここ
const vuetify = createVuetify({
  components,
  directives,
  theme: {
    themes: {
      light: {
        dark: true,
        colors: {
          primary: "#cc0f0fff", //1a237e
          secondary: "#64c6ffff",
          info: "#C62828",
          warning: "#FFE57F",
        },
      },
    },
    options: { customProperties: true },
  },
});



app.use(vuetify);
app.mount("#app");
